const apiVersion = 'v1'

let domain = 'https://api.loca.shop/'
let cdnDomain = 'https://images.loca.shop/'
let adminUrl = 'https://gestao.loca.shop/'
let locashopUrl = 'https://loca.shop/'
let displayUrl = 'https://loca.shop/'

if (process.env.NODE_ENV === 'development') { // DEV
  domain = 'http://localhost/'
  cdnDomain = 'http://localhost/'
  adminUrl = 'http://localhost:3000/'
  locashopUrl = 'http://localhost:8080/'
  displayUrl = 'http://localhost:8081/'
}
if (process.env.NODE_ENV === 'homolog') { // HOMOLOG
  domain = 'https://api-homolog.loca.shop/'
  cdnDomain = 'https://images.test.loca.shop/'
  adminUrl = 'https://gestao-homolog.loca.shop/'
  locashopUrl = 'https://homolog.loca.shop/'
  displayUrl = 'https://homolog.loca.shop/'
}
export const apiDomain = domain
export const adminURL = adminUrl
export const locashopURL = locashopUrl
export const displayURL = displayUrl
export const apiURL = apiDomain + apiVersion + '/admin'
export const cdnURL = cdnDomain

export const userURL = 'user'
export const usersURL = 'users'
export const loginURL = apiDomain + 'oauth/token'
export const passwordEmailURL = 'password/email'
export const passwordResetURL = 'password/reset'

export const supportContact = '31998038196'



// WEBPACK FOOTER //
// ./src/config.js